import React, { useEffect, useState } from "react";
import "./Styles.css";
import { RiBookOpenLine } from "react-icons/ri";
import Axios from "../../../api/axios/Axios";

export default function RugbyVicU16s2025Preview() {
  document.title = "Katch | Blog";

  const [views, setViews] = useState(0);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => apiGetViewCount(), []);

  useEffect(() => apiUpdateViewCount(), [scrolled]);

  const apiGetViewCount = () => {
    Axios.get("/api/v1/blog/views", { params: { blogId: 1 } })
      .then((res) => {
        const { views } = res.data;
        return setViews(views);
      })
      .catch((err) => console.error(err));
  };

  const apiUpdateViewCount = () => {
    let timer;

    const handleScroll = () => setScrolled(true);

    window.addEventListener("scroll", handleScroll);

    if (scrolled) {
      // Start 30s timer after first scroll
      timer = setTimeout(async () => {
        Axios.post("/api/v1/blog/views", {
          blogId: 1,
        })
          .then((res) => {
            const { views } = res.data;
            setViews(views);
          })
          .catch((err) => console.error(err));
      }, 3000);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timer);
    };
  };

  return (
    <main className="article-container">
      <section className="team-photo-section">
        <h1 className="article-title">
          Will Rugby Victoria’s U16s Make History in 2025?
        </h1>
        <p className="article-subtitle">
          Super Rugby U16s kickoff - can Victoria finally reach two wins from
          four?
        </p>

        <div className="blog-meta">
          <span>By Katch Sports</span>
          <span>•</span>
          <time dateTime={new Date().toISOString()}> September 22, 2025</time>
          <span style={{ alignItems: "center" }}>
            <RiBookOpenLine style={{ marginRight: "0.2rem" }} />
            {views}
          </span>
        </div>

        <br />

        <img
          src="https://d337v8ouw0jp30.cloudfront.net/rugby-victoria-u16s-2025-preview.jpg"
          alt="Rugby Victoria U16s Team 2025"
          className="team-photo"
        />
      </section>

      {/* Article card */}
      <article className="article-body">
        <section>
          <p>
            Rugby Victoria’s Under 16s are set to kick off their Super Rugby
            competition this weekend, and there’s a growing sense that this
            year’s squad could be the one to finally break new ground. Since
            joining the national competition, Victoria’s U16s have worked
            tirelessly to close the gap on Australia’s traditional rugby
            powerhouses. But the question remains:{" "}
            <em>
              will 2025 be the year they crack two wins out of four for the very
              first time?
            </em>
          </p>

          <br />

          <p>
            The signs are promising. Fresh from a gritty trial win over the
            Brumbies, the team showed resilience, structure, and a sharp
            attacking edge that has often been missing in past campaigns. Depth
            across key positions, a mobile forward pack, and a playmaking group
            of backs give this side balance and belief.
          </p>

          <br />

          <p>
            Rugby Victoria’s U16s face no easy path. With the Waratahs, Reds,
            Brumbies, and Western Force all boasting deep talent pools and
            strong rugby pathways, every game will demand composure and grit.
            But this year’s Victorian side isn’t just here to compete, they
            believe they can win.
          </p>

          <br />

          <p>
            The coaches have drilled the squad in a disciplined, high pressure
            style of rugby, fast and physical but also focused on growth,
            development and the excitement of young talents eager to challenge
            themselves and seize the opportunities ahead.
          </p>

          <br />

          <p>
            A breakthrough season at this level would mean more than just wins
            on the scoreboard. For Rugby Victoria, it would mark an important
            step in building a stronger identity, inspiring young players across
            the state, and showing that the pathways are producing talent
            capable of matching it with the best. Every try scored and tackle
            made reinforces the growth of the game in Victoria.
          </p>

          <br />

          <p>
            And for the players themselves, the stakes couldn’t be higher. A
            standout campaign in this competition could open the door to
            national recognition, with several boys putting their hand up for
            potential selection in the Australian U16s squad. That opportunity
            adds extra motivation, giving this season the feel of something
            bigger than just four matches.
          </p>

          <br />

          <p>
            With all matches streaming live on Stan Sport, fans have the chance
            to follow every moment of this campaign. Win or lose, the Rugby
            Victoria U16s are writing another chapter in the state’s rugby
            story. But if momentum is anything to go by, 2025 could be the year
            history is made.
          </p>

          <br />

          {/* Game coverage info */}
          <div className="game-info-hero">
            <div className="article-hero-cta">
              <p className="small-text">Watch live on</p>
              <a href="https://www.stan.com.au/">Stan Sport</a>
            </div>

            <br />

            <p>
              <strong>Upcoming Matches & Coverage:</strong>
            </p>
            <ul style={{ listStyle: "none" }}>
              <li>
                Victoria vs. Western Force: 28 Sept 2025, 10:30 AM, Tompkins
                Park
              </li>
              <li>Victoria vs. Reds: 3 Oct 2025, 1:40 PM, Ballymore Stadium</li>
              <li>
                Victoria vs. Brumbies: 18 Oct 2025, 1:00 PM, La Trobe University
                Sports Park
              </li>
              <li>
                Victoria vs. Waratahs: 26 Oct 2025, 2:00 PM, La Trobe University
                Sports Park
              </li>
            </ul>
          </div>
        </section>
      </article>

      <section className="squad-section">
        <h2>2025 Rugby Victoria U16s Squad</h2>
        <div className="squad-list">
          <ul>
            <li>
              Alan Asiata<span className="club">Wyndham City RC</span>
            </li>
            <li>
              Dharczy Vaiimene<span className="club">Endeavour Hills RC</span>
            </li>
            <li>
              Eitini Samasoni<span className="club">Melton RC</span>
            </li>
            <li>
              Esene Junior Paleti<span className="club">Wyndham City RC</span>
            </li>
            <li>
              Exodus Talia<span className="club">Endeavour Hills RC</span>
            </li>
            <li>
              Hamish Ward<span className="club">Endeavour Hills RC</span>
            </li>
            <li>
              Ihakaraia Toko<span className="club">Wyndham City RC</span>
            </li>
            <li>
              Israel Leuga<span className="club">Melton RC</span>
            </li>
            <li>
              Jackson Holloway<span className="club">Moorabbin RC</span>
            </li>
            <li>
              Jeroni Fa'ataape<span className="club">Wyndham City RC</span>
            </li>
            <li>
              Joshua Fa'amausili<span className="club">Lara SC</span>
            </li>
            <li>
              Kaeleb Brown<span className="club">Harlequin RC</span>
            </li>
            <li>
              Kohen Tavita<span className="club">Wyndham City RC</span>
            </li>
            <li>
              Thomas Sidhu<span className="club">Moorabbin RC</span>
            </li>
            <li>
              Laurenson Silaga<span className="club">Shepparton RC</span>
            </li>
          </ul>

          <ul>
            <li>
              Lenix Aiga<span className="club">Wyndham City RC</span>
            </li>
            <li>
              Leroy Fiu<span className="club">Northern RC</span>
            </li>
            <li>
              Matthew Migao<span className="club">Wyndham City RC</span>
            </li>
            <li>
              Nathaniel Tafunai<span className="club">Melton RC</span>
            </li>
            <li>
              Noah Sale<span className="club">Sunshine College</span>
            </li>
            <li>
              Sage Jayawardana<span className="club">Footscray RC</span>
            </li>
            <li>
              Santino Gregg-Matiu
              <span className="club">Endeavour Hills RC</span>
            </li>
            <li>
              Sione Finau<span className="club">Melton RC</span>
            </li>
            <li>
              Sione Lemusu<span className="club">Point Cook SC</span>
            </li>
            <li>
              Tate Galloway<span className="club">Endeavour Hills RC</span>
            </li>
            <li>
              Te Raukura O Te Korowai Kingi -{" "}
              <span className="club">Wyndham City RC</span>
            </li>
            <li>
              Titus Apineru<span className="club">Harlequin RC</span>
            </li>
            <li>
              TJ Lio<span className="club">Melton RC</span>
            </li>
            <li>
              Trizah Coffin<span className="club">The Grange</span>
            </li>
            <li>
              Waimana Manukau<span className="club">Geelong RC</span>
            </li>
            <li>
              Sami Gazal<span className="club">Harlequins RC</span>
            </li>
          </ul>
        </div>
      </section>

      <div className="tags">
        <p>
          Tags: <span>Rugby Victoria</span>
          <span>U16s</span>
          <span>Super Rugby</span>
        </p>
      </div>

      {/* Footer / CTA */}
      <footer className="article-footer">
        <p className="small-text">
          &copy; 2025 Katch Sports. All rights reserved.
        </p>
        <div className="footer-actions">
          <a href="/" className="btn-primary">
            Home
          </a>
          <a href="/support" className="btn-secondary">
            Contact
          </a>
        </div>
      </footer>
    </main>
  );
}
